/* eslint-disable react-hooks/exhaustive-deps */
import { Card, List, Tag } from 'antd';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';
import { DEFAULT_PRODUCT_URL } from '../../config';
import Paragraph from 'antd/lib/typography/Paragraph';
import { convertPrice } from '../../utils/display';

interface IProps {
  item: any;
  fromPage: string;
  promotionProducts: any;
  isMember: boolean;
}

const ProductItem = ({
  item,
  fromPage,
  promotionProducts,
  isMember,
}: IProps) => {
  const addDefaultImage = async (ev: any) => {
    if (!ev.target.errored) {
      ev.target.errored = true;
      ev.target.src = DEFAULT_PRODUCT_URL;
    }
  };
  return (
    <>
      <List.Item key={item._id} style={{ marginBottom: '10px' }}>
        <Link
          to={`/shops/product-detail/?from=${fromPage}&id=${item._id}`}
          onClick={(event) => {
            if (!item.isReadyToSell) {
              event.preventDefault();
            }
          }}
        >
          <Card
            hoverable
            className={styles.productItem}
            bodyStyle={{
              padding: '7px 0 0 0',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'baseline',
            }}
            cover={
              <img
                alt="product"
                src={
                  item.product[0].files.length
                    ? item.product[0].files[0]
                    : DEFAULT_PRODUCT_URL
                }
                onError={async (e) => {
                  await addDefaultImage(e);
                }}
              />
            }
          >
            <Paragraph
              ellipsis={{ rows: 3, symbol: '...' }}
              style={{ height: '66px', marginBottom: 0 }}
            >
              {item.product[0].productName}
            </Paragraph>

            {promotionProducts.includes(item.product[0].code) ? (
              <Tag
                color="#d4380d"
                style={{ fontSize: '10px', lineHeight: '18px' }}
              >
                ร่วมโปรโมชั่น
              </Tag>
            ) : (
              <div style={{ height: '20px' }}>&nbsp;</div>
            )}

            <div className={styles.antTextSecondary}>
              {item.isReadyToSell ? (
                <strong>
                  ฿&nbsp;
                  {isMember ? (
                    <>
                      {convertPrice(item.memberPrice)}
                      <div
                        style={{
                          textDecoration: 'line-through',
                          fontSize: '10px',
                          color: 'red',
                        }}
                      >
                        {convertPrice(item.price)}
                      </div>
                    </>
                  ) : (
                    <>{convertPrice(item.price)}</>
                  )}
                </strong>
              ) : (
                <>
                  <span style={{ color: 'darkslategray' }}>
                    กรุณาติดต่อร้านค้าเพื่อซื้อสินค้ารายการนี้
                  </span>
                </>
              )}
            </div>
          </Card>
        </Link>
      </List.Item>
    </>
  );
};

export default ProductItem;
